import { render } from "./customNotifyWindow.vue?vue&type=template&id=7066d53d&scoped=true"
import script from "./customNotifyWindow.vue?vue&type=script&lang=js"
export * from "./customNotifyWindow.vue?vue&type=script&lang=js"

import "./customNotifyWindow.vue?vue&type=style&index=0&id=7066d53d&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7066d53d"]])

export default __exports__